module.exports = __webpack_public_path__ + "static/media/shell32_42.1f9758a4.ico";